import BaseRequest from "../lib/BaseRequest";

export default class AdminRequest extends BaseRequest {
  clearCache() {
    let url = "/admin/api/clear-cache";
    return this.post(url);
  }

  getBankAccounts(params) {
    let url = "/admin/api/bank-accounts";
    return this.get(url);
  }

  createBankAccount(params) {
    let url = "/admin/api/bank-account";
    return this.post(url, params);
  }

  updateBankAccount(params) {
    let url = "/admin/api/bank-account";
    return this.put(url, params);
  }

  deleteBankAccount(params) {
    let url = "/admin/api/bank-account";
    return this.del(url, params);
  }

  getCustomerUsdTotal(params) {
    let url = "/admin/api/customer-usd-total";
    return this.get(url, params);
  }

  getWallet(currency, params) {
    let url = "/admin/api/wallets/" + currency;
    return this.get(url, params);
  }

  createWallet(params) {
    let url = "/admin/api/wallets";
    return this.post(url, params);
  }

  removeWallet(id) {
    let url = "/admin/api/wallets/" + id;
    return this.del(url);
  }

  getUsers(params) {
    let url = "/admin/api/users2";
    return this.get(url, params);
  }

  getTransactions(params) {
    let url = "/transaction";
    return this.get(url, params);
  }

  getUsdTransaction(params) {
    let url = "/admin/api/usd-transactions";
    return this.get(url, params);
  }

  getOrderFutureRecords(params) {
    let url = "api/v1/order";
    return this.getFuture(url, params);
  }
  getPositionFutureRecords(params) {
    let url = "api/v1/positions/admin";
    return this.getFuture(url, params);
  }
  get24hPrices(params) {
    let url = "api/v1/ticker/24h";
    return this.getFuture(url, params);
  }
  getTradeFutureRecords(params) {
    let url = "api/v1/trade";
    return this.getFuture(url, params);
  }

  rejectUsdTransaction(params) {
    let url = "/admin/api/reject-usd-transaction";
    return this.put(url, params);
  }

  confirmUsdTransaction(params) {
    let url = "/admin/api/confirm-usd-transaction";
    return this.put(url, params);
  }

  sendTransaction(params) {
    let url = "/admin/api/send-transaction";
    return this.put(url, params);
  }

  cancelTransaction(params) {
    let url = "/admin/api/cancel-transaction";
    return this.put(url, params);
  }

  getUserBalances(params) {
    let url = "/users/user-balances";
    return this.get(url, params);
  }

  getUserAccessHistories(params) {
    let url = "/admin/api/user_access_histories";
    return this.get(url, params);
  }

  getOrderHistory(params) {
    let url = "/admin/api/orders";
    return this.get(url, params);
  }

  getAMALNet(params) {
    let url = "/admin/api/amal-net";
    return this.get(url, params);
  }

  getProfit(params) {
    let url = "/admin/api/profit";
    return this.get(url, params);
  }

  getWithdrawalLimits() {
    let url = "/withdrawal-limits";
    return this.get(url);
  }

  updateWithdrawalLimit(params) {
    let url = "/admin/api/withdrawal-limit";
    return this.put(url, params);
  }

  updateCoinStepUnitByUsd(params) {
    let url = "/admin/api/currency-step-unit-usd";
    return this.put(url, params);
  }

  getCurrencyStepUnitsByUsd(params) {
    let url = "/admin/api/currency-step-unit-usd";
    return this.get(url, params);
  }

  getDepositPageBadge() {
    let url = "/admin/api/deposit-badge";
    return this.get(url);
  }

  getMasterDataFuture() {
    let url = "api/v1/master-data";
    return this.getFuture(url);
  }

  getInstruments() {
    let url = "api/v1/instruments";
    return this.getFuture(url);
  }

  getWithdrawPageBadge() {
    let url = "/admin/api/withdraw-badge";
    return this.get(url);
  }

  getUserKyc(params) {
    const url = `/kyc`;
    return this.get(url, params);
  }

  getDetailUserKyc({ id } = {}) {
    const url = `/kyc/${encodeURIComponent(id)}`;
    return this.get(url);
  }
  verifyKyc(params) {
    let url = "/admin/api/user-kyc/verify";
    return this.put(url, params);
  }

  rejectKyc(params) {
    let url = "/admin/api/user-kyc/reject";
    return this.put(url, params);
  }

  getNotices(params) {
    let url = "/admin/api/admin-notice";
    return this.get(url, params);
  }

  getEditNotice(params) {
    let url = "/admin/api/admin-notice/edit";
    return this.get(url, params);
  }

  updateNotice(params) {
    let url = "/admin/api/admin-notice/update";
    return this.post(url, params);
  }

  createNotice(params) {
    let url = "/admin/api/admin-notice/create";
    return this.post(url, params);
  }

  deleteNotice(id) {
    let url = "/admin/api/admin-notice/delete/" + id;
    return this.del(url, id);
  }

  getUserLoginHistory(params) {
    let url = "/admin/api/user-login-history/";
    return this.get(url, params);
  }
  getListEmailMarketing(params) {
    let url = "/admin/api/email-marketing";
    return this.get(url, params);
  }

  editEmailMarketing(params) {
    let url = "/admin/api/email-marketing/edit";
    return this.get(url, params);
  }

  updateEmailMarketing(params) {
    let url = "/admin/api/email-marketing/update";
    return this.post(url, params);
  }
  createEmailMarketing(params) {
    let url = "/admin/api/email-marketing/create";
    return this.post(url, params);
  }

  deleteEmailMarketing(id) {
    let url = "/admin/api/email-marketing/delete/" + id;
    return this.del(url, id);
  }

  sendEmailMarketing(params) {
    let url = "/admin/api/email-marketing/send";
    return this.post(url, params);
  }

  getEmailMarketingSendedHistories(id, params) {
    let url = "/admin/api/email-marketing/sent-emails/" + id;
    return this.get(url, params);
  }

  getCountries() {
    const url = "/admin/api/countries";
    return this.get(url);
  }

  getAdmins(params) {
    const url = "/admin/api/administrators";
    return this.get(url, params);
  }

  getAdministratorById(id) {
    const url = `/admin/api/administrators/${id}`;
    return this.get(url);
  }

  updateAdministrator(params) {
    const url = "/admin/api/administrators/update";
    return this.post(url, params);
  }

  createAdministrator(params) {
    const url = "/admin/api/administrators/create";
    return this.post(url, params);
  }

  deleteAdministrator(id) {
    const url = "/admin/api/administrators/delete";
    return this.del(url, { id: id });
  }

  getAllUser() {
    const url = "/api/get-all";
    return this.get(url);
  }

  getAdmin(params) {
    let url = `/api/get-admin/`;
    return this.get(url, params);
  }

  getPriceGroupCurrency() {
    let url = "/price-group-currency";
    return this.get(url);
  }

  getPriceGroupCurrencyCoins(currency) {
    let url = currency
      ? `/price-group-currency/coins?currency=${currency}`
      : "/price-group-currency/coins";
    return this.get(url);
  }

  getAllCoin() {
    let url = "/admin/api/get-all-coin";
    return this.get(url);
  }

  getMarketFeeSetting(params) {
    let url = "/trading-fees";
    return this.get(url, params);
  }

  updateMarketFeeSetting(params) {
    let url = `/market-fee-setting`;
    return this.put(url, params);
  }

  getEnableFeeSetting(params) {
    const { currency } = params;
    let url = "/enable-fee-setting";
    return this.get(url, { currency });
  }

  getUserEnableFeeSetting(params) {
    let url = "/user-enable-fee-setting";
    return this.get(url, params);
  }

  createUserEnableFeeSetting(params) {
    let url = "/toggle";
    return this.post(url, params);
  }

  updateUserEnableFeeSetting(params) {
    let url = "/admin/api/enable-fee-setting/update-user-settings";
    return this.put(url, params);
  }

  deleteUserEnableFeeSetting(params) {
    let url = "/enable-fee-setting/user-settings/" + params.id + "/delete";
    return this.del(url, params);
  }

  getEnableWithdrawalSetting(params) {
    let url = "/enable-withdrawal-settings";
    return this.get(url, params);
  }

  getUserEnableWithdrawalSetting(params) {
    let url = "/enable-withdrawal-settings/user-settings";
    return this.get(url, params);
  }

  createUserEnableWithdrawalSetting(params) {
    const url = "/enable-withdrawal-settings/user-settings";
    const body = {
      email: params.email,
      coin: params.coin,
      allCoins: !!params.allCoins,
      ...(typeof params.enableWithdrawal !== "undefined"
        ? { enableWithdrawal: params.enableWithdrawal }
        : typeof params.enable_withdrawal !== "undefined"
        ? { enableWithdrawal: !!params.enable_withdrawal }
        : {}),
    };
    return this.post(url, body);
  }

  updateUserEnableWithdrawalSetting(params) {
    const id = params.id ?? params.user_id ?? params._id;
    const url = `/enable-withdrawal-settings/user-settings/${id}`;
    const body = {
      enableWithdrawal:
        typeof params.enableWithdrawal !== "undefined"
          ? !!params.enableWithdrawal
          : !!params.enable_withdrawal,
    };
    return this.put(url, body);
  }

  deleteUserEnableWithdrawalSetting(params) {
    const id = params.id ?? params.user_id ?? params._id;
    const url = `/enable-withdrawal-settings/user-settings/${id}`;
    return this.del(url);
  }

  getEnableTradingSetting(params) {
    let url = "/enable-trading-setting";
    return this.get(url, {
      currency: params.currency,
    });
  }

  getUserEnableTradingSetting(params = {}) {
    const url = "/enable-trading-setting/user-settings";
    const q = {};
    if (params.page != null) q.page = params.page;
    if (params.limit != null) q.limit = params.limit;
    if (params.search_key) q.search_key = params.search_key;
    if (params.searchKey) q.search_key = params.searchKey;
    if (params.coin) q.coin = params.coin;
    if (params.currency) q.currency = params.currency;
    if (params.sort) q.sort = params.sort;
    if (params.sort_type) q.sort_type = params.sort_type;
    if (params.sortType) q.sort_type = params.sortType;

    return this.get(url, q);
  }

  createUserEnableTradingSetting(params) {
    let url = "/enable-trading-setting/add-user-settings";
    return this.post(url, params);
  }

  updateUserEnableTradingSetting(params = {}) {
    const url = "/enable-trading-setting/update-user-settings";

    let enable_trading = params.enable_trading;
    if (enable_trading == null && typeof params.is_enable === "boolean") {
      enable_trading = params.is_enable ? "enable" : "disable";
    }

    const body = {
      email: params.email || params.userEmail || params.emailAddress,
      coin: params.coin,
      currency: params.currency,
      enable_trading,
    };
    Object.keys(body).forEach((k) => body[k] == null && delete body[k]);

    return this.put(url, body);
  }

  updateEnableCoinSetting(params) {
    let url = "/enable-trading-setting/update-coin-settings";
    return this.put(url, {
      currency: params.currency,
      coin: params.coin,
      is_enable: params.is_enable,
    });
  }

  deleteUserEnableTradingSetting(params = {}) {
    const url = `/user-settings/${params.id}/delete`;

    const body = {
      email: params.email || params.userEmail || params.emailAddress,
      currency: params.currency,
      coin: params.coin,
      allMarket:
        typeof params.allMarket === "boolean"
          ? params.allMarket
          : !!params.all_market,
      inThisMarket:
        typeof params.inThisMarket === "boolean"
          ? params.inThisMarket
          : !!params.in_this_market,
    };
    Object.keys(body).forEach((k) => body[k] == null && delete body[k]);

    return this.post(url, body);
  }

  changeStatusCircuitBreakerSetting(params) {
    let url = "/admin/api/circuit-breaker/change-status";
    return this.post(url, params);
  }

  getCircuitBreakerSetting(params) {
    let url = "/admin/api/circuit-breaker/settings";
    return this.get(url, params);
  }

  updateCircuitBreakerSetting(params) {
    let url = "/admin/api/circuit-breaker/settings";
    return this.post(url, params);
  }

  getCoinPairSetting(params) {
    let url = "/admin/api/circuit-breaker/coin-pair-setting";
    return this.get(url, params);
  }

  updateCoinPairSetting(params) {
    let url = "/admin/api/circuit-breaker/update-coin-pair-setting";
    return this.post(url, params);
  }

  getColdWallets() {
    let url = "/wallet/cold-wallets";
    return this.get(url);
  }
  getColdWalletSetting() {
    let url = "/wallet/cold-wallet-setting";
    return this.get(url);
  }

  updateColdWalletSetting(params) {
    let url = `/wallet/cold-wallet-setting`;
    return this.put(url, params);
  }

  sendMailUpdateColdWallet(params) {
    let url = "/wallet/cold-wallet-setting";
    return this.post(url, params);
  }

  getListUserGroupSetting(params) {
    let url = "/admin/api/user-group-setting";
    return this.get(url, params);
  }

  deleteGroupSetting(id) {
    let url = "/admin/api/user-group-setting/" + id;
    return this.del(url);
  }

  addGroupSetting(params) {
    let url = "/admin/api/user-group-setting";
    return this.post(url, params);
  }

  updateGroupSetting(params) {
    let url = "/admin/api/user-group-setting/update";
    return this.post(url, params);
  }

  getListUserGroup(params) {
    let url = "/admin/api/user-group";
    return this.get(url, params);
  }

  updateUserGroup(params) {
    let url = "/admin/api/user-group";
    return this.post(url, params);
  }

  deleteUserGroup(params) {
    let url = "/admin/api/user-group/delete";
    return this.post(url, params);
  }

  getListUserAirdropSetting(params) {
    let url = "/admin/api/airdrop/user-settings";
    return this.get(url, params);
  }

  getPairs(params) {
    let url = "/admin/api/airdrop/get-pairs";
    return this.get(url, params);
  }

  getAutoDividendSetting(params) {
    let url = "/admin/api/auto-dividend/setting";
    return this.get(url, params);
  }

  updateAllStatus(params) {
    let url = "/admin/api/auto-dividend/update-all-status";
    return this.post(url, params);
  }

  updateStatus(params) {
    let url = "/admin/api/auto-dividend/update-status";
    return this.post(url, params);
  }

  resetMaxBonus(params) {
    let url = "/admin/api/auto-dividend/reset-max-bonus";
    return this.post(url, params);
  }

  updateAutoDividendSetting(params) {
    let url = "/admin/api/auto-dividend/update-setting";
    return this.post(url, params);
  }

  updateUserAirdropSetting(params) {
    let id = params["user_id"];
    let url = "/admin/api/airdrop/user-settings/" + id + "/update";
    return this.put(url, params);
  }

  deleteUserAirdropSetting(params) {
    let id = params["user_id"];
    let url = "/admin/api/airdrop/user-settings/" + id + "/delete";
    return this.del(url, params);
  }

  changeStatusAirdropSetting(params) {
    let url = "/admin/api/airdrop/change-status";
    return this.post(url, params);
  }

  changeStatusFeeWallet(params) {
    let url = "/admin/api/airdrop/change-status-fee-wallet";
    return this.post(url, params);
  }
  changeStatusEnableFeeWallet(params) {
    let url = "/admin/api/airdrop/change-status-enable-fee-wallet";
    return this.post(url, params);
  }

  createAirdropUserSetting(params) {
    let url = "/admin/api/airdrop/user-settings";
    return this.post(url, params);
  }

  getAirdropSetting() {
    let url = "/admin/api/airdrop/settings";
    return this.get(url);
  }

  getAirdropSettingToRender(timezone) {
    let url = "/admin/api/airdrop/render-settings";
    return this.get(url, timezone);
  }

  getAllAirdropSetting() {
    let url = "/admin/api/airdrop/all-settings";
    return this.get(url);
  }

  updateAirdropSetting(params) {
    let url = "/admin/api/airdrop/settings";
    return this.post(url, params);
  }

  getAirdropHistory(params) {
    let url = "/admin/api/airdrop/history";
    return this.get(url, params);
  }

  getAirdropPaymentHistory(params) {
    let url = "/admin/api/airdrop/payment-history";
    return this.get(url, params);
  }

  getCashbackHistory(params) {
    let url = "/admin/api/airdrop/cashback-history";
    return this.get(url, params);
  }

  getTotalBonus(params) {
    let url = "/admin/api/airdrop/total-bonus";
    return this.get(url, params);
  }

  // list trading volume ranking

  getTradingVolumneRanking(params) {
    let url = "/admin/api/airdrop/volume-ranking";
    return this.get(url, params);
  }

  // Apply bonus
  applyBonusBalance(params) {
    let url = "/admin/api/bonus-balance";
    return this.post(url, params);
  }

  // Refund bonus
  refundBonusBalance(params) {
    let url = "/admin/api/refund-bonus-balance";
    return this.post(url, params);
  }

  // Get manual dividend history

  getManualDividendHistory(params) {
    let url = "/admin/api/airdrop/manual-dividend-history";
    return this.get(url, params);
  }

  // Get manual dividend history

  getAutoDividendHistory(params) {
    let url = "/admin/api/airdrop/auto-dividend-history";
    return this.get(url, params);
  }

  checkOldAdminPassword(params) {
    let url = "/auth/check-old-password";
    return this.post(url, params);
  }

  changeAdminPassword(params) {
    let url = "/auth/change-password";
    return this.post(url, params);
  }

  changeStatusReferralSetting(params) {
    let url = "/admin/api/referral/change-status";
    return this.post(url, params);
  }

  getReferralSetting() {
    let url = "/admin/api/referral/settings";
    return this.get(url);
  }

  updateReferralSetting(params) {
    let url = "/admin/api/referral/settings";
    return this.post(url, params);
  }

  getReferralHistory(params) {
    let url = "/admin/api/referral/history";
    return this.get(url, params);
  }

  getInformationCoins() {
    let url = "/admin/api/get-infomation-coins";
    return this.get(url);
  }

  getInstrument(params) {
    let url = "/admin/api/instruments/all";
    return this.get(url, params);
  }

  getContractSettings(params) {
    let url = "/admin/api/margin/contract-settings";
    return this.get(url, params);
  }

  updateContractSetting(params) {
    let url = "/admin/api/margin/update-contract";
    return this.put(url, params);
  }

  updateFeeStatusSetting(params) {
    let url = "/admin/api/margin/update-fee-status";
    return this.put(url, params);
  }

  getTradingSettings(params) {
    let url = "/admin/api/margin/trading-settings";
    return this.get(url, params);
  }

  updateTradingSetting(params) {
    let url = "/admin/api/margin/update-trading-setting";
    return this.put(url, params);
  }

  addTradingSetting(params) {
    let url = "/admin/api/margin/add-trading-setting";
    return this.post(url, params);
  }

  deleteTradingSetting(params) {
    let url = "/admin/api/margin/delete-trading-setting";
    return this.post(url, params);
  }

  getInstrumentFuture(params) {
    let url = "api/v1/instruments/list-contract";
    return this.getFuture(url, params);
  }

  createInstrumentFuture(params) {
    let url = "api/v1/instruments";
    return this.postFuture(url, params);
  }
  getDetailInstrument(params) {
    let url = "api/v1/instruments/detail-contract";
    return this.getFuture(url, params);
  }

  updateInstrument(params) {
    let url = "api/v1/instruments/update-contract";
    return this.putFuture(url, params);
  }

  getAsset(params) {
    let url = "api/v1/assets";
    return this.getFuture(url, params);
  }
}
